// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"594":"about","685":"final"}[chunkId] + "." + {"594":"494c6521","685":"4749a2c4"}[chunkId] + ".css";
};